import { WatcherrNetworkError } from "@watcherr/resources";

export const delay = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

const CALL_TIMEOUT_MS = 30e3;

export const createTimeoutPromise = (timeout: number) => new Promise<never>((resolve, reject) => {
  setTimeout(() => {
    reject(new WatcherrNetworkError());
  }, timeout);
});

// A wrapper functiont to retry a call if it has a network error
// and to timeout the call if it takes too long
export const backoff = async<T>(
  call: (signal?: AbortSignal) => Promise<T>, 
  config?: {
    maxRetries?: number, 
    timeout?: number, 
    shouldAbort?: boolean 
  }, 
  retryCount = 0, 
  lastError?: any,
) : Promise<T> => {
  if (retryCount > (config?.maxRetries ?? 5)) throw lastError

  const controller = config?.shouldAbort ? new AbortController() : undefined;

  const timeOut = setTimeout(
    () => controller?.abort() ?? undefined,
    config?.timeout ?? CALL_TIMEOUT_MS
  )

  try {
    const res = await call(controller?.signal);
    clearTimeout(timeOut)
    return res
  } catch (error) {
    clearTimeout(timeOut);
    if (error instanceof WatcherrNetworkError || error.name === "AbortError") {
      const cap = 60 * 1e3;

      retryCount++
      const delayTime = Math.floor(
        Math.random() * (Math.min(cap, 2 ** retryCount))
      ) * 1e3
      await delay(delayTime);
      return backoff(call, config, retryCount + 1, error);
    } else {
      throw error
    }
  }
};
